/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';
import Table from 'react-bootstrap/Table';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import Switch from "react-switch";

// project imports
import { messagelist, itemimagelist, secret_key, messageReply, messageUpdate, messageBulkUpdate, messageDt } from 'shared/settings/apiconfig';
import { getSellerUrl, getSellerHeaders, getBuyerHeaders, getBuyerUrl } from 'shared/http';
import store from 'features/store';
import toast from 'shared/toast';
import Notes from '../sales/Notes';
import Validators from 'shared/validators';

// style imports
import './MessageReply.scss';
import { itemdetail, token, bid_history, bidders_list } from "shared/settings/apiconfig";
import ChangeBidder from '../sales/ChangeBidder';
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to list messages
 * 
 * @param props
 * 
 * @returns html code to render the message list
 * 
**/

export class MessageReply extends Component {
    messageRoute = ['/messages/read', '/messages/unread', '/messages/replied', '/messages/deleted'];
    replyinitialize;    // need to initialize each time reply is clicked

    constructor(props) {
        super(props);
        this.replyinitialize = { value: '', error: '', valid: false, validators: [Validators.required()] };
        this.state = {
            params: this.props.itemsId ? this.props : this.props.match.params,
            pageLoading: false,
            replyLoading: false,
            replyBox: -1,
            replyMessage: { ...this.replyinitialize },
            replyNavigate: false,
            replyModal: -1,
            bidderModal: false,
            messageList: [],
            itemsDetails: {},
            bid_history: [],
            additionalnotes: '',
            itemListData: [],
            videoModal: false,
            videoUrl: "",
            secretKey: "",
            bidderCount: 0,
            currentBid: 0,
            windowWidth: window.innerWidth,
            selectedMessage: [],
            deleting: false,
            replyMessageList: '',
            messageId: this.props.location.state?.row?.id ? this.props.location.state?.row?.id : this.props.match.params.messageId,
            itemId: this.props.location.state?.row?.itemid ? this.props.location.state?.row?.itemid : this.props?.match?.params?.itemId,            
            errorpageredirect: false,
            errorType: '' 
        };
        this.approveBack = false
    }

    componentDidMount() {
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });
        this.getSecretKey();
        // this.getBidToken();
        window.addEventListener('resize', this.getwindowwidth);
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }
    readMssage = () => {
        if (this.props.location.pathname.includes('/messages/item/reply')) {
            const ids = this.state.messageList.map(item => item.id)
            const data = { "ids": ids, "read": 1 };
            axios.post(getSellerUrl(messageBulkUpdate), JSON.stringify({ data: data }), getSellerHeaders())
        }
    };

    componentWillUnmount() {
        store.dispatch({ type: 'SET_SIDEBAR', payload: true });
        window.removeEventListener('resize', this.getwindowwidth);
    }
    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToList();
        }
    }
    getwindowwidth = () => {
        this.setState({
            windowWidth: window.innerWidth
        });
    }
    getSecretKey() {
        this.setState({
            pageLoading: true
        })
        axios.get(getSellerUrl(`${secret_key}`), getSellerHeaders()).then(
            response => {
                if (response.data.status.toLowerCase() === 'success') {
                    this.setState({
                        buyerToken: response.data.accessToken
                    }, () => {
                        this.getItemMessages();
                    })
                }
            }).catch(
                error => {
                    this.setState({
                        secretKey: ""
                    })
                }
            );
    }
    getBidToken() {
        var data = {
            "data": {
                "app_identifier": "ctbids_seller",
                "app_secret": this.state.secretKey,
            }
        }
        axios.post(getBuyerUrl(`${token}`), JSON.stringify(data), getBuyerHeaders()).then(
            resp => {
                this.setState({
                    buyerToken: resp.data.accessToken
                }, () => {
                    this.getBidHistory(resp.data.accessToken)
                    this.getbidders(resp.data.accessToken)
                })
            }
        ).catch(
            error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    ...this.state,
                })
            }
        );
    }
    getbidders(token) {
        axios.get(getBuyerUrl(`${bidders_list}${this.state.itemId}`), getBuyerHeaders(token)).then(
            response => {
                if (response.data.status === 'success') {
                    this.setState({
                        ...this.state,
                        disabledChangeBidder: false,
                        biddersList: response.data.data
                    })
                }
                else {
                    this.setState({
                        ...this.state,
                        disabledChangeBidder: true,
                    })
                }
            }).catch(
                error => {
                    this.setState({
                        ...this.state,
                        disabledChangeBidder: true,
                    },()=>{
                        console?.clear()
                    })
                }
            );
    }
    getBidHistory(token) {
        axios.get(getBuyerUrl(`${bid_history}/${this.state.itemId}/`), getBuyerHeaders(token)).then(
            response => {
                if (response.data.data.bidhistory.length > 0) {
                    this.setState({
                        bidderCount:  Array.from(new Set(response.data.data.bidhistory.map(elem => elem['buyerid']))).length,
                        bid_history: response.data.data.bidhistory,
                        currentBid: response.data.data.bidhistory[0]["bidprice"]
                    });
                }
                else {
                    this.setState({
                        bidderCount: 0,
                        bid_history: [],
                        currentBid: 0
                    });
                }
            }
        ).catch(
            error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    ...this.state,
                    bidderCount: 0,
                    bid_history: [],
                    currentBid: 0
                })
            }
        );
    }
    /* Getting items details */
    getItemsDetails = () => {
        axios.get(getSellerUrl(`${itemdetail}/${this.state.itemId}`), getSellerHeaders()).then(
            response => {
                this.setState({
                    ...this.state,
                    itemsDetails: response.data.data[0],
                    pageLoading: false
                });
            }
        ).catch(
            error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    ...this.state,
                    error: true
                })
            }
        );
    }

    getItemMessages = async () => {
        this.setState({ pageLoading: true });
        const data = {
            filter: [{ field: this.state.messageId ? "id" : "itemid", value: this.state.messageId ? this.state.messageId : parseInt(this.state.itemId), op: '=', join: 'AND' }],
            sort: [{ field: 'createddate', direction: 'desc' }]
        };
        await axios.post(getSellerUrl(messageDt), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                const messageList = [...response.data.data];

                messageList.forEach(message => {
                    if (message.reply.length > 0) {
                        message['reply'] = message['reply'];
                    } else {
                        message['reply'] = [];
                    }
                });
                if (messageList.length <= 0) {
                    this.setState({
                        ...this.state,
                        errorpageredirect: true,
                        errorType: 'noData'
                    });
                }
                this.setState({
                    // pageLoading: false,
                    messageList: [...messageList],
                    itemId: messageList[0].itemid
                }, () => {
                    this.getBidHistory(this.state.buyerToken)
                    this.getbidders(this.state.buyerToken)
                    this.getItemsDetails();
                    this.showDisplayImage();
                    this.readMssage()
                });
            })
            .catch(error => {
                this.setState({ pageLoading: false });
                if(error.response?.status == 401 || error.response?.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
                // toast.error(error?.response?.data['message']);
            });
    };

    /* Calculating shipping and handling fee */
    shippingfeeAndHandlingfee = () => {
        const shippingfee = this.state.itemsDetails.shippingfee ? this.state.itemsDetails.shippingfee : 0;
        const handlingfee = this.state.itemsDetails.handlingfee ? this.state.itemsDetails.handlingfee : 0;
        const returnVal = parseFloat(shippingfee + handlingfee).toFixed(2);
        return returnVal;
    }

    // input change
    onInputChange = (event) => {
        const validatedForm = Validators.formValidation({ replyMessage: this.state.replyMessage }, event);

        this.setState({
            replyMessage: validatedForm['formControls']['replyMessage']
        });
    };
    // closes modal box
    onViewBidder = () => {
        this.setState({ bidderModal: true });
    };
    // closes modal box
    onModalAction = (index) => {
        this.setState({ replyModal: index });
    };

    // opens reply box
    onReplyBoxShow = (index) => {
        this.setState({
            replyBox: index,
            replyMessage: { ...this.replyinitialize },
            replyNavigate: false
        });
    };

    // closes reply box
    onReplyBoxCancel = () => {
        this.setState({ replyBox: -1 });
    };

    onReplyNavigate = (event) => {
        this.setState({ replyNavigate: event.target.checked });
    };
    /* Converting date into required format */
    dateFormat = (date) => {
        if (date) {
            return moment.utc(date).local().format('MM/DD/YYYY hh:mm A');
        }
        return '- - -';
    }
    /* Converting value to decimal */
    convertingToDecimal = (value, len = 2) => {
        const check = value ? value : 0;
        return parseFloat(check).toFixed(len);
    }
    /* convert utc  local time */
    convertLocalTime(date) {
        return moment(moment.utc(date)).local().format('MM/DD/YYYY hh:mm:ss A');
    }
    getTimeZone = () => {
        const timeZone = momentTz.tz.guess();
        return momentTz.tz(timeZone).zoneAbbr();
    }
    /* called when note clicked */
    viewNotes = () => {
        this.setState({
            ...this.state,
            modal: true
        });
    }

    /* called when save or note closed */
    hideNotes = () => {
        this.setState({
            ...this.state,
            modal: false
        })
    }
    showDisplayImage = () => {
        this.setState({
            itemListData: []
        })
        // let field = ["itemid", "url", "saletitle"]
        let itemListData = [];
        let filter = [
            {
                "field": "itemid",
                "value": Number(this.state.itemId),
                "op": "=",
                "join": "AND"
            },
            // {
            //     "field": "isdisplayimage",
            //     "value": 1,
            //     "op": "=",
            //     "join": "AND"
            // }
        ]
        var data = {
            "filter": filter,
            // "field": field
        };
        axios.post(getSellerUrl(itemimagelist), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    if (response.data != null) {
                        itemListData = response.data.data;
                        this.setState({
                            itemListData: itemListData,
                        })
                    }
                }

            })
            .catch(error => {
                this.setState({
                    itemListData,
                })
                // toast.error(error.response.data['message']);

            })
    }
    saveReply = async (mIndex) => {
        if (this.state.replyMessage.valid) {
            this.setState({ replyLoading: true });
            const data = {
                id: this.state.messageList[mIndex]['id'],
                reply: this.state.replyMessage.value,
                itemid: this.state.itemId
            };
            await axios.post(getSellerUrl(messageReply), JSON.stringify({ data: data }), getSellerHeaders())
                .then(response => {
                    // const messageList = [...this.state.messageList];
                    // messageList[mIndex]['messagereply'].push(data.messagereply);
                    // this.setState({ messageList: messageList });
                    toast.success('Replied to message');
                    this.onReplyBoxCancel();
                    this.getItemMessages();
                    this.setState({ replyLoading: false });

                    if (this.state.replyNavigate) {
                        this.props.history.push({ pathname: '/messages/unread', state: this.props.location.state });
                    }
                })
                .catch(error => {
                    this.setState({ replyLoading: false });
                    toast.error(error?.response?.data['message']);
                });
        }
    };

    navigateToList = () => {
        store.dispatch({ type: 'SET_MESSAGE_ITEMID', payload: { setItemId: true, itemId:  this.props?.location?.state?.messageViewitemId }});
        this.props.history.push({ pathname: this.props.location?.state?.stateMaintain?.pathname ? this.props.location.state.stateMaintain.pathname : "/home", state: this.props.location.state });
    };

    toggleChange = (message, mIndex) => {
        let { messageList } = this.state;
        let isPublic = !messageList[mIndex]['ispublic'];
        messageList[mIndex]['ispublic'] = isPublic
        this.setState({
            messageList
        })

        const data = {
            "id": message.id,
            "ispublic": isPublic ? 1 : 0
        };
        axios.put(getSellerUrl(messageUpdate), JSON.stringify({ data: data }), getSellerHeaders()).then(
            response => {

            })
            .catch(error => {

            });
    }
    dateFormatCloseTime = (date) => {
        let newdate = moment.tz(date, date).local();
        return `${newdate.format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
    }

    selectMessage = (event, data) => {
        event.preventDefault();
        const selectedMessage = this.state.selectedMessage;
        const index = selectedMessage.findIndex(x => x.id === data.id);
        if (index !== -1) {
            selectedMessage.splice(index, 1);
        } else {
            selectedMessage.push(data);
        }
        this.setState({
            selectedMessage
        });
    }

    isMessageSelected = (data) => {
        return this.state.selectedMessage.findIndex(x => x.id === data.id) > -1;
    }

    isAllSelected = () => {
        var unDeletedMessageList = this.state.messageList.filter((elem) => { return elem.isdeleted == 0 });
        var unDeletedSelectedList = this.state.selectedMessage.filter(elem => { return elem.isdeleted == 0; });
        return unDeletedMessageList.length > 0 && unDeletedSelectedList.length > 0 && unDeletedMessageList.length === unDeletedSelectedList.length;
    }

    toggleSelectAll = (event) => {
        event.preventDefault();
        this.setState({
            selectedMessage: this.isAllSelected() ? [] : JSON.parse(JSON.stringify(this.state.messageList.filter(elem => { return elem.isdeleted == 0; })))
        });
    }

    deleteSelected = () => {
        this.setState({
            deleting: true
        }, async () => {
            let messageList = this.state.selectedMessage.map(x => x.id);
            let replyList = this.state.selectedMessage[0].reply.map(x => x.id);
            const data = { "ids": messageList.concat(replyList), "isdeleted": 1 };
            await axios.post(getSellerUrl(messageBulkUpdate), JSON.stringify({ data: data }), getSellerHeaders())
                .then(async (response) => {
                    const getMessage = {
                        filter: [
                            { field: "id", value: this.state.messageId, op: '=', join: 'AND' },
                        ],
                        sort: [{ field: 'createddate', direction: 'desc' }]
                    };
                    await axios.post(getSellerUrl(messageDt), JSON.stringify(getMessage), getSellerHeaders())
                        .then(response => {
                            const messageList = [...response.data.data];
                            messageList.forEach(message => {
                                if (message.reply.length > 0) {
                                    message['reply'] = message['reply'];
                                } else {
                                    message['reply'] = [];
                                }
                            });
                            this.setState({
                                messageList: messageList,
                                deleting: false,
                                selectedMessage: []
                            });
                        })
                        .catch(error => {
                            this.setState({
                                deleting: false
                            });
                            toast.error(error?.response?.data['message']);
                        });
                })
                .catch(error => {
                    this.setState({
                        deleting: false
                    });
                    toast.error(error?.response?.data['message']);
                });
        });

    }
   
    
   


    render() {
        if (this.state.errorpageredirect) {
            // redirect to Not-Found if wrong Messageid
            return <NoData {...this.props} type={this.state.errorType} />
        }

        return (
            <div className="items-main-div" style={{ overflowX: "hidden", overflowY: "auto" }}>
                {
                    this.state.pageLoading && !this.state.error ?
                        <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                        </div> : !this.state.pageLoading && !this.state.error ? <div className="item-responsive">
                            <div style={{ padding: "1%" }}>
                                <span onClick={() => {
                                    this.navigateToList();
                                }} className="clickable">
                                    <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                                    <span style={{ paddingLeft: "1em" }}>Back</span>
                                </span>
                            </div>

                            <div className="d-md-flex items-min-h">
                                <div className="border items-column-2 set-pad-l" style={{ width: this.state.windowWidth < 425 ? (this.state.windowWidth - 30) : "27%", marginLeft: this.state.windowWidth < 425 ? "2%" : "0%" }}>
                                    <div className="item-content">
                                        <div className="item-title">Sale Title</div>
                                        <div className="mb-set">
                                            {this.state.itemsDetails.saletitle}
                                        </div>
                                    </div>
                                    <div className="item-content">
                                        <div className="item-title">Item Title</div>
                                        <div className="mb-set">
                                            {this.state.itemsDetails.title}
                                        </div>
                                    </div>
                                    {this.state.itemsDetails.itemclosetime ?
                                        <div className="item-content">
                                            <div className="item-title">Item Closed Time</div>
                                            <div className="mb-set">
                                                <div>{`${this.dateFormatCloseTime(this.state.itemsDetails.itemclosetime)}`}</div>
                                            </div>
                                        </div>
                                        : ''}
                                    <div className="item-content">
                                        <div className="item-title">Item History</div>
                                        <div className="mb-set">
                                            <div>Status - {this.state.itemsDetails.itemstatus}</div>
                                            <div>{this.state.itemsDetails.updatedby ? this.state.itemsDetails.updatedby : this.state.itemsDetails.createdby}</div>
                                            <div>{this.dateFormat(this.state.itemsDetails.modifieddate)}</div>
                                        </div>
                                    </div>
                                    <div className="item-content">
                                        <div className="item-title">SKU</div>
                                        <div className="mb-set" style={{ wordBreak: 'break-all' }}>
                                            {this.state.itemsDetails.SKU}
                                        </div>
                                    </div>
                                    <div className="item-content">
                                        <div className="item-title">Area &amp; Category</div>
                                        <div className="mb-set">
                                            <div>{this.state.itemsDetails.area},</div>
                                            <div>{this.state.itemsDetails.category}</div>
                                        </div>
                                    </div>
                                    <div className="item-content">
                                        <div className="item-title">L &#10005; W &#10005; H &amp; Weight</div>
                                        <div className="mb-set">
                                            {this.state.itemsDetails.length ? this.state.itemsDetails.length : 0}" &#10005; {this.state.itemsDetails.width ? this.state.itemsDetails.width : 0}" &#10005; {this.state.itemsDetails.height ? this.state.itemsDetails.height : 0}" &amp; {this.state.itemsDetails.weight ? this.state.itemsDetails.weight : 0}Lbs
                                        </div>
                                    </div>
                                    <div className="item-content">
                                        <div className="item-title">Item Settings</div>
                                        <div className="mb-set">
                                            <div>Starting: &#36;{this.state.itemsDetails.startingprice ? this.convertingToDecimal(this.state.itemsDetails.startingprice) : this.convertingToDecimal(0)}</div>
                                            <div>Reserve: &#36;{this.state.itemsDetails.reserveprice ? this.convertingToDecimal(this.state.itemsDetails.reserveprice) : this.convertingToDecimal(0)}</div>
                                            <div>Direct: &#36;{this.state.itemsDetails.buynowprice ? this.convertingToDecimal(this.state.itemsDetails.buynowprice) : this.convertingToDecimal(0)}</div>
                                            <div>BP: {this.state.itemsDetails.buyerspremium ? this.convertingToDecimal(this.state.itemsDetails.buyerspremium, 3) : this.convertingToDecimal(0, 3)}%</div>
                                            <div>Tax: {this.state.itemsDetails.tax ? this.convertingToDecimal(this.state.itemsDetails.tax, 3) : this.convertingToDecimal(0, 3)}%</div>
                                            <div>Shipping: &#36;{this.state.itemsDetails.shippingfee ? this.convertingToDecimal(this.state.itemsDetails.shippingfee) : this.convertingToDecimal(0)}</div>
                                            <div>Handling: &#36;{this.state.itemsDetails.handlingfee ? this.convertingToDecimal(this.state.itemsDetails.handlingfee) : this.convertingToDecimal(0)}</div>
                                            {/* <div>S&amp;H: &#36;{this.shippingfeeAndHandlingfee()}</div> */}
                                        </div>
                                    </div>
                                    {this.state.itemsDetails.itemviewurl ?
                                        <div className="item-content">
                                            <div className="item-title">Item Url</div>
                                            <span><a href={this.state.itemsDetails.itemviewurl} target="_blank">{this.state.itemsDetails.itemviewurl}</a></span>
                                        </div> : ''}
                                    <div className="item-content">
                                        <div className="item-title">Notes</div>
                                        <div className="mb-set">
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/notes.svg`} alt="notes" className="clickable" onClick={this.viewNotes} />
                                        </div>
                                    </div>
                                </div>
                                <div className="border items-column-4" style={{ width: this.state.windowWidth < 425 ? (this.state.windowWidth - 30) : "40%", marginLeft: this.state.windowWidth < 425 ? "2%" : "0%" }}>
                                    {
                                        this.state.itemsDetails.itemtypeid > 1 ?
                                            <div className="set-pad-l mt-3">
                                                <div className="content-column">
                                                    <div className="item-content">
                                                        <div className="d-flex align-items-center" style={{ justifyContent: "space-between" }}>
                                                            <div className="item-title">Bidding History</div>
                                                            <Button variant="dark" className="mr-2"
                                                               
                                                                onClick={() => this.onViewBidder()}>View Bidder
                                                            </Button>   </div>
                                                        <div className="mb-set"></div>
                                                        {/* <div className="line-break"></div> */}
                                                        <div className="line-break"></div>
                                                        <div className="mb-unset d-flex mt-3" style={{ padding: "2% 4%", justifyContent: "space-around" }}>
                                                            <div className="mx-2">{`Bidders: ${this.state.bidderCount}`}</div>
                                                            <div className="mx-2">{this.state.itemsDetails.itemstatus === "Sold" ? "Sold Price:" : "Current Bid:"} &#36;<span>{this.state.currentBid !== "" ? parseFloat(this.state.currentBid).toFixed(2) : "0.00"}</span></div>
                                                            <div className="mx-2">Goal: &#36;<span>{this.state.itemsDetails.goal !== null ? this.state.itemsDetails.goal : "0.00"}</span>[&#36;<span>{this.state.currentBid !== "" ? parseFloat(this.state.currentBid).toFixed(2) : "0.00"}</span>]</div>
                                                            <div className="mx-1">Value: &#36;<span>{this.state.itemsDetails.valuation !== null ? this.state.itemsDetails.valuation : "0.00"}</span>[&#36;<span>{this.state.currentBid !== "" ? parseFloat(this.state.currentBid).toFixed(2) : "0.00"}</span>]</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                    }
                                    {
                                        this.state.itemsDetails.itemtypeid > 1 ?
                                            <div className="line-break"></div>
                                            : null
                                    }
                                    <div className="communication-column set-pad-l mt-3">
                                        <div className="item-content">
                                            {this.state.itemListData.length > 0 ?
                                                <div className="item-title">Images</div> : <></>}
                                            <div className="mb-set"></div>
                                        </div>
                                        <div className="d-flex mb-5" style={{ flexWrap: "wrap", }}>
                                            {
                                                this.state.itemListData.length > 0 ?
                                                    this.state.itemListData.map((item, index) =>
                                                        item.type === "image" ?
                                                            <div className="image-container" style={{ display: "inline-block", }} >
                                                                <img className="display-image" src={"url" in item && item.url ? item.url : `${process.env.PUBLIC_URL}/static/images/image_thumbnail.png`} alt="item display" style={{ width: "140px", height: "135px" }}></img>
                                                            </div>
                                                            :
                                                            <div className="image-container" style={{ display: "inline-block", }} >
                                                                <div className="d-flex flex-row justify-content-center align-items-center border bg-dark"
                                                                    style={{ position: 'relative', width: 'max-content', marginLeft: "6px" }}>
                                                                    <i className="far fa-play-circle fa-3x text-white clickable" style={{ position: 'absolute', zIndex: '1' }}
                                                                        onClick={() => this.setState({
                                                                            videoModal: true,
                                                                            videoUrl: item.url
                                                                        })}
                                                                    ></i>
                                                                    <video onContextMenu={event => event.preventDefault()} style={{ width: '140px', height: '135px', opacity: 0.7 }}>
                                                                        <source src={item.compressedurl ? item.compressedurl : item.url} />
                                                                    </video>
                                                                </div>
                                                            </div>

                                                    ) :
                                                    <></>
                                            }</div>
                                    </div>
                                </div>
                                <div className="border items-column-4" style={{ width: this.state.windowWidth < 425 ? (this.state.windowWidth - 30) : "40%", marginLeft: this.state.windowWidth < 425 ? "2%" : "0%", height: "616px", overflow: "auto" }}>
                                    <div className="communication-column set-pad-l mt-3">
                                        <div className="item-content">
                                        <div className="d-flex align-items-center" style={{ justifyContent: "space-between" }}>
                                            <div className="item-title">Messages &amp; Reply</div>
                                            <div className='d-flex align-items-center'>
                                                <Button variant="secondary" className="mr-2" onClick={this.deleteSelected} disabled={this.state.selectedMessage.length === 0 || this.state.deleting}>  Delete {this.state.deleting ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                                                <div className={`custom-checkbox-div ${this.isAllSelected() ? 'checked' : ''}`} style={{ opacity: `${this.state.messageList.filter(elem => { return elem.isdeleted == 0; })}` ? "" : '0.3' , pointerEvents: `${this.state.messageList.filter(elem => { return elem.isdeleted == 0; })}` ? "" : 'none' }} onClick={(event) => { event.stopPropagation(); this.toggleSelectAll(event) }}></div>  
                                            </div>
                                        </div>
                                        <div className="mb-set"></div>
                                        <div className="line-break"></div>
                                        </div>
                                        <div className="d-flex flex-column w-100 w-75 h-100 border message-content" style={{ position: "relative" }}>
                                            {
                                                this.state.messageList.length ?
                                                    this.state.messageList.map((message, mIndex) => {
                                                        let ispublic = message.ispublic
                                                        return (
                                                            <div key={mIndex}
                                                                className={`${message['reply'].length ? "bg-grey-light" : "bg-not-replied"} mb-3 mt-3 py-2 px-3`}>
                                                                {/* buyer name */}
                                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                                    <div style={{ paddingRight: "3%", width: "42%" }}>{ispublic ? "Remove from Public View" : "Allow for Public View"}</div>
                                                                    <Switch checked={ispublic} handleDiameter={15} onChange={() => { this.toggleChange(message, mIndex) }}
                                                                        offColor="#a50050" onColor="#408905" height={25} width={50}
                                                                        uncheckedIcon={
                                                                            <div style={{ display: "flex", alignItems: "center", height: "100%", width: "20px", fontSize: 15, }}>
                                                                            </div>
                                                                        }
                                                                        checkedIcon={
                                                                            <div style={{ display: "flex", alignItems: "center", height: "100%", width: "20px", fontSize: 15, }}>
                                                                            </div>
                                                                        }
                                                                        disabled={message.isdeleted == 1}
                                                                    />
                                                                    <div className="delete-checkbox">
                                                                        <div className={`custom-checkbox-div ${this.isMessageSelected(message) ? 'checked' : ''}`} style={{ opacity: `${message.isdeleted == 1 ? "0.3" : ""}`, pointerEvents: `${message.isdeleted == 1 ? "none" : ""}` }} onClick={ message.isdeleted == 1 ? null : (event) => { event.stopPropagation(); this.selectMessage(event, message) }}></div>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex flex-row justify-content-end">
                                                                    <span className="text-grey-name">{  message['membershipCompleted'] ? <img src={`${process.env.PUBLIC_URL}/static/images/membership.png`} alt="" width={'20px'}  />: ''} {message['createdby']} </span>
                                                                </div>

                                                                {/* message */}
                                                                <div className="w-100 d-flex flex-row">
                                                                    <b>Message:</b>
                                                                    <span className="w-100 ml-1">{message['message']}</span>
                                                                    <span className="" style={{ float: 'right',width: '50%' }} >{moment.utc(message['createddate']).local().format('MM/DD/YYYY hh:mm A')} </span>
                                                                </div>

                                                                {/* reply */}
                                                                {
                                                                    message['reply'].length ?
                                                                        <div className="w-100 d-flex flex-row">
                                                                            <b>Reply:</b>
                                                                            <span className="w-100 ml-1">{ message['reply'][0].reply}</span>
                                                                            <span className="" style={{ float: 'right',width: '50%' }} >{moment.utc( message['reply'][0].createddate).local().format('MM/DD/YYYY hh:mm A')} </span>
                                                                        </div> :
                                                                        null
                                                                }

                                                                {/* more replies and reply button */}
                                                                <div className={`w-100 d-flex flex-row ${message['reply'].length > 1 ? "justify-content-between" : "justify-content-end"}`}>
                                                                    {
                                                                        message['reply'].length > 1 ?
                                                                            <span className="text-link clickable" onClick={() => this.onModalAction(mIndex)}>Read all replies</span> :
                                                                            null
                                                                    }
                                                                    {
                                                                        this.state.replyBox === -1 || this.state.replyBox !== mIndex ?
                                                                            <span className={`${message.isdeleted == 1 ? "" : "clickable"}`} style={{ opacity: `${message.isdeleted == 1 ? "0.3" : ""}` }} onClick={ message.isdeleted == 1 ? null : () => this.onReplyBoxShow(mIndex)}>
                                                                                <i className="fa fa-reply text-grey-name mr-1" />
                                                                                Reply
                                                                            </span> :
                                                                            <div className="d-flex flex-column w-100">
                                                                                <Form.Control as="textarea" style={{ height: "126px" }} placeholder="Reply to message..." rows={3}
                                                                                    name="replyMessage" value={this.state.replyMessage.value}
                                                                                    onChange={this.onInputChange} autoFocus />
                                                                                <div className="d-flex flex-row justify-content-end my-2">
                                                                                    <Form.Check id="replyNavigate" type="checkbox" label="Reply and navigate to list" value={this.state.replyNavigate}
                                                                                        onChange={this.onReplyNavigate} />
                                                                                </div>
                                                                                <div className="d-flex flex-row justify-content-end">
                                                                                    <Button variant="secondary" className="mr-2" onClick={() => this.saveReply(mIndex)}
                                                                                        disabled={!this.state.replyMessage.valid || this.state.replyLoading}>Reply</Button>
                                                                                    <Button className="bg-white text-dark" onClick={this.onReplyBoxCancel}
                                                                                        disabled={this.state.replyLoading}>Cancel</Button>
                                                                                </div>
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    }) :
                                                    <div className="w-100 h-100 d-flex flex-row align-items-center justify-content-center">
                                                        No messages available
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div></div>
                        </div> : ''
                }
                <Modal show={this.state.videoModal} size="md" animation={false} onHide={() => this.setState({ videoModal: false })}>
                    <Modal.Header>
                        <Button type="button" onClick={() => this.setState({
                            videoModal: false
                        })} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
                        <div style={{ width: '400px', height: '400px' }}>
                            <video disablePictureInPicture src={this.state.videoUrl} controls
                                autoPlay="autoplay" style={{ width: '100%', height: '100%' }}></video>
                        </div>
                    </Modal.Body>
                </Modal>
                {/* dialog box to show all replies for a message */}
                <Modal show={this.state.replyModal > -1} size="lg" animation={false} scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <Button type="button" onClick={() => this.onModalAction(-1)} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center" >
                        {

                            this.state.replyModal > -1 ?
                                <div className="w-100 d-flex flex-row border py-3 px-2">
                                    <b>Message:</b>
                                    <span className="w-100 ml-1">{this.state.messageList[this.state.replyModal]['message']}</span>
                                    <span className="w-30 ml-1">{moment.utc(this.state.messageList[this.state.replyModal]['createddate']).local().format('MM/DD/YYYY hh:mm A')} </span>
                                </div> :
                                null
                        }
                        <div style={{ width: '100%', height: '400px', maxHeight: '80vw' }}>
                            {
                                this.state.replyModal > -1 ?
                                    this.state.messageList[this.state.replyModal]['reply'].map((reply, mIndex) => (
                                            <div className="w-100 d-flex flex-row py-3 px-2" style={{ borderBottom: "1px dashed black" }}>
                                                <b>Reply:</b>
                                                <span className="w-100 ml-1" style={{ wordBreak: "break-word" }}>{reply.reply}</span>
                                                <span className="w-30 ml-1" style={{ wordBreak: "break-word" }}>{moment.utc(reply.createddate).local().format('MM/DD/YYYY hh:mm A')}</span>
                                            </div>
                                    )) :
                                    null
                            }
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={this.state.bidderModal} size="lg" animation={false} scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <div className="item-content">
                            <div className="item-title" style={{ color: "#9f2241" }}><b>Bidder Details</b></div>
                            <div className="mb-set"></div>
                        </div>
                        <Button type="button" onClick={() => this.setState({
                            bidderModal: false
                        })} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center" >
                        {this.state.bid_history.length ?
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th style={{ width: '30%' }}>Date &amp; Time</th>
                                        <th>Bidder</th>
                                        <th>Bid Amount</th>
                                        <th>Proxy Max Bid</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.bid_history.map((row, index) => (

                                            <tr>
                                                <td>{row['createddate'] !== "" ? this.convertLocalTime(row['createddate']) : "- - -"} {this.getTimeZone()}</td>
                                                <td>{row['nickname']}</td>
                                                <td>${parseFloat(row['bidprice']).toFixed(2)}</td>
                                                <th>{row['maxproxyprice']}</th>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                            : <div className="w-100 h-100 d-flex  justify-content-center" style={{ padding: "5%", fontSize: "15px" }}>No data available</div>}
                    </Modal.Body>
                </Modal>
                {this.state.modal ?
                    <Notes modal={this.state.modal} id={this.state.itemId} name='item' hideNotes={this.hideNotes} data={this.state.itemsDetails} /> : ''
                }
                {this.state.changeBidderModal && <ChangeBidder itemsId={this.state.itemId} token={this.state.buyerToken} show={this.state.changeBidderModal} closeModal={() => {
                    this.setState({ changeBidderModal: false })
                }} />}

            </div>
        );
    }
}